import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthenticationFooterComponent } from '../authentication-footer/authentication-footer.component';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [RouterOutlet, AuthenticationFooterComponent],
})
export class AuthenticationComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
